export const DISMISS_ONBOARDING = 'DISMISS_ONBOARDING'